import $ from 'jquery';
import {showFormResponse, clearStatusMessages } from '../common/json-response';

let saveBtn, form;
let fieldsData;

function getFields() {
  // типы полей для отправки
  const fieldTypeText = 'text';
  const fieldTypeTextArea = 'textarea';
  const fieldTypeNumber = 'number';
  const fieldTypeRadio = 'radio';
  const fieldTypeSelect = 'select';
  const fieldTypeCheckbox = 'checkbox';

  // типы чекбоксов
  // multiple - значит можно выбрать несколько вариантов, например, для номинаций
  const checkTypeMultiple = 'multiple';

  const selectorsWithType = [
    {
      type: fieldTypeText,
      selector: '.send-field[type="text"]:not([disabled])'
    },
    {
      type: fieldTypeTextArea,
      selector: 'textarea.send-field:not([disabled])'
    },
    {
      type: fieldTypeNumber,
      selector: '.send-field[type="number"]:not([disabled])'
    },
    {
      type: fieldTypeSelect,
      selector: 'select.send-field:not([disabled]) option:checked'
    },
    {
      type: fieldTypeRadio,
      selector: '.send-field[type="radio"]:checked:not([disabled])'
    },
    {
      type: fieldTypeCheckbox,
      selector: '.send-field[type="checkbox"]:checked:not([disabled])'
    },
  ];

  const fieldsData = {};

  selectorsWithType.forEach(item => {
    const fields = form.querySelectorAll(item.selector);

    fields?.forEach(input => {
      const checkType = input.getAttribute('data-check-type');
      let fieldName;

      if (item.type === fieldTypeSelect) {
        const parentSelect = input.closest('select.send-field');
        fieldName = parentSelect.name;
      }

      if (checkType === checkTypeMultiple) {
        if (!fieldsData[input.name]) {
          fieldsData[input.name] = [];
        }

        fieldsData[input.name].push(input.value);
      } else if (fieldName) {
        fieldsData[fieldName] = input.value;
      } else {
        fieldsData[input.name] = input.value;
      }
    });
  });

  return fieldsData;
}

function getSendUrl() {
  let url = saveBtn.getAttribute('data-url');

  return url;
}

function initContestCustomFieldsSettings() {
  saveBtn = document.querySelector('#contest-custom-fields-settings-save');
  form = document.querySelector('#form-custom-fields-settings');

  if (!saveBtn || !form) {
    return;
  }

  saveBtn?.addEventListener('click', function (e) {
    e.preventDefault();

    // убираем предыдущие сообщения
    clearStatusMessages();
    fieldsData = getFields();
    const url = getSendUrl();

    $.ajax({
      type: "POST",
      url: url,
      dataType: 'json',
      data: fieldsData,
      success: function (data) {
        if (data.redirectTo?.length) {
          window.location.href = data.redirectTo;
        }

        showFormResponse(data);

        if (data.status === 'success') {
          const uncheckedTypes = document.querySelectorAll('.field-type:not(:checked)');
          uncheckedTypes?.forEach(item => {
            item.disabled = true;
          });
        }
      },
      error: function (data) {
        showFormResponse(data);
      },
    });
  });
}

export { initContestCustomFieldsSettings }
